// Shared across this directory
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { AuthHeader, Icon } from '../../components';
import { lineHeight, theme, toRem } from '../../design';

export const Layout = styled.div`
  flex-flow: column;
  justify-content: center;
  padding: 0 ${toRem(theme.space['2xl'])};
  text-align: center;
  align-items: center;
  flex-grow: 1;
  max-width: ${toRem(520)};
  gap: ${toRem(theme.space['3xl'])};

  header {
    background: inherit;
  }
`;

export const StyledAuthHeader = styled(AuthHeader)`
  h1 {
    font-size: ${toRem(theme.font.size['4xl'])};
    line-height: ${lineHeight(theme.font.size['4xl'])};
  }
  p {
    font-size: ${toRem(theme.font.size.md)};
    line-height: ${lineHeight(theme.font.size.md)};
  }
`;

export const ContentContainer = styled.div`
  flex-flow: column;
  width: 100%;
  background: ${theme.color.neutral[100]};
  padding: ${toRem(theme.space.xl)};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  border-radius: ${toRem(8)};
  gap: ${toRem(theme.space.sm)};
  text-align: start;
`;

const SkeletonContainer = styled.div`
  width: 100%;
  flex-flow: column;
  gap: ${toRem(theme.space.sm)};
`;

export const LoadingHeader = () => (
  <SkeletonContainer>
    <Skeleton width={100} height={45} />
    <Skeleton width={400} height={36} />
    <Skeleton count={3} />
  </SkeletonContainer>
);

const AccessDeniedIconContainer = styled.div`
  border-radius: 50%;
  height: ${toRem(88)};
  width: ${toRem(88)};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.color.warning[25]};
  margin-bottom: ${toRem(theme.space.xl)};

  svg {
    fill: ${theme.color.warning[50]};
    height: ${toRem(55)};
    width: ${toRem(55)};
  }
`;

export const AccessDeniedIcon = () => (
  <AccessDeniedIconContainer>
    <Icon icon="Caution" />
  </AccessDeniedIconContainer>
);
